export default "__VITE_ASSET__CpZFEjVc__"